export enum PageTypeEnum {
    None = "none",
    Agreements = "agreements",
    Payments = "payments",
    Settlements = "settlements",
    Terminals = "terminals",
    Transactions = "transactions",
    Employees = "employees",
    Dashboard = "dashboard",
    NotFound = "notFound",
    MerchantAgreements = "merchantAgreements",
    MerchantSettlements = "merchantSettlements",
    ApiKeys = "apiKeys",
    Webhooks = "webhooks",

    // Details
    PartnerAgreementDetails = "partnerAgreementDetails",
}

export enum ReportType {
    // Reports
    None = "none",
    Agreements = "agreements",
    Payments = "payments",
    Settlements = "settlements",
    Terminals = "terminals",
    Transactions = "transactions",
    Employees = "employees",
    Dashboard = "dashboard",
    NotFound = "notFound",
    MerchantAgreements = "merchantAgreements",
    MerchantSettlements = "merchantSettlements",
    ApiKeys = "apiKeys",
    Webhooks = "webhooks",

    // Agreement Details
    SettlementDefinitions = "settlementDefinitions",
    LinkedMerchantAgreements = "linkedMerchantAgreements",
    CommissionDefinitions = "commissionDefinitions",
}
